var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-refund-select-items flex flex-auto flex-col" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.selections, function (item) {
        return _c(
          "RefundableOrderItemView",
          _vm._b(
            {
              key: item.id,
              attrs: {
                "is-selected": item.selected,
                "selected-reason": item.reason,
                selected: item.selected,
                reason: item.reason,
                "is-valid-refund": item.isValidRefund,
                "refund-amount": item.refundAmount,
                "refund-type": item.refundType,
                "refund-reasons": _vm.refundReasons,
              },
              on: {
                "update:selected": function ($event) {
                  return _vm.$set(item, "selected", $event)
                },
                "update:reason": function ($event) {
                  return _vm.$set(item, "reason", $event)
                },
                "update:isValidRefund": function ($event) {
                  return _vm.$set(item, "isValidRefund", $event)
                },
                "update:is-valid-refund": function ($event) {
                  return _vm.$set(item, "isValidRefund", $event)
                },
                "update:refundAmount": function ($event) {
                  return _vm.$set(item, "refundAmount", $event)
                },
                "update:refund-amount": function ($event) {
                  return _vm.$set(item, "refundAmount", $event)
                },
                "update:refundType": function ($event) {
                  return _vm.$set(item, "refundType", $event)
                },
                "update:refund-type": function ($event) {
                  return _vm.$set(item, "refundType", $event)
                },
              },
            },
            "RefundableOrderItemView",
            item,
            false
          )
        )
      }),
      _vm._v(" "),
      _c("RefundShippingCard", {
        attrs: {
          "shipping-total": _vm.shippingTotal,
          "refund-shipping": _vm.refundShipping,
        },
        on: {
          "update:refundShipping": function ($event) {
            _vm.refundShipping = $event
          },
          "update:refund-shipping": function ($event) {
            _vm.refundShipping = $event
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n      Select items you want to refund\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "\n      Please select the items you would like to refund and add a refund\n      reason.\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }